// extracted by mini-css-extract-plugin
export default {"container":"Card_container__5ni9k","content":"Card_content__E9H46","img":"Card_img__RAfgr","text":"Card_text__wA50H"};